import * as yup from 'yup';
import { TFunction } from 'i18next';

const MAX_NOTE_LENGTH = 300;

export function createValidationSchema(t: TFunction) {
  return yup.object({
    roleid: yup.number().required().min(1, t('common.formError.required')),
    user: yup
      .mixed()
      .test(
        'user-required',
        t('common.formError.required'),
        value => value !== undefined && value?.username?.length > 0
      )
      .test(
        'no-groups',
        t('groups.invite.popup.form.errors.noGroups'),
        value => !value?.isGroup
      ),
    note: yup
      .string()
      .max(
        MAX_NOTE_LENGTH,
        t('groups.invite.popup.form.errors.noteTooLong', {
          max: MAX_NOTE_LENGTH,
        })
      ),

    // config options
    options: yup.object(),
  });
}
